/* eslint-disable no-undef */
var imagesLoaded = require('imagesloaded');
import ScrollMagic from 'scrollmagic';
import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Masonry from 'masonry-layout';
// make Masonry a jQuery plugin
jQueryBridget('masonry', Masonry, $);

export default {
  init() {
    // JavaScript to be fired on all pages
    $(document).ready(function () {
      if (window.outerWidth > 768) {
        let skrollableEls = $('.skrollable');
        if (skrollableEls.length > 0) {
          // eslint-disable-next-line no-unused-vars
          var s = skrollr.init({ forceHeight: false });
        }
      }
    });

    /** GLOBAL VARIABLES */
    // var body = document.querySelector('body');
    /** END GLOBAL VARIABLES */

    /** SKIP LINK NAVIGATION */
    $('#skip-to-content').click(function () {
      // strip the leading hash and declare
      // the content we're skipping to
      var skipTo = '#' + this.href.split('#')[1];
      // Setting 'tabindex' to -1 takes an element out of normal
      // tab flow but allows it to be focused via javascript
      $(skipTo)
        .attr('tabindex', -1)
        .on('blur focusout', function () {
          // when focus leaves this element,
          // remove the tabindex attribute
          $(this).removeAttr('tabindex');
        })
        .focus(); // focus on the content container
    });
    /** END SKIP LINK NAVIGATION */

    // eslint-disable-next-line no-unused-vars
    $('.ticker:not(.revealed)').counterUp({ delay: 10, time: 1000 });

    // Header scroll animation

    function headerScroll() {
      if (!$('.site-header').hasClass('.site-header--sub-menu-active')) {
        var scrollPosition = $(window).scrollTop();
        var siteHeader = $('.site-header');
        if (scrollPosition < 0) {
          if (scrollPosition > 0) {
            siteHeader.addClass('site-header--hidden');
          } else {
            siteHeader.removeClass('site-header--hidden');
          }
        }
        //    if (scrollPosition > 100) {
        //        $('#header').addClass('header-border');
        //    } else {
        //        $('#header').removeClass('header-border');
        //    }
      }
    }
    var lastScrollPosition = 0;
    function headerReveal() {
      if (!$('.site-header').hasClass('.site-header--sub-menu-active')) {
        var scrollPosition = $(window).scrollTop();
        var siteHeader = $('.site-header');
        if (scrollPosition > 15) {
          if (scrollPosition < lastScrollPosition) {
            siteHeader.removeClass('site-header--hidden');
          } else {
            siteHeader.addClass('site-header--hidden');
          }
          lastScrollPosition = scrollPosition;
        }
      }
    }

    $(document).ready(function () {
      headerScroll();
    });

    $(window).scroll(function () {
      headerScroll();
      headerReveal();
    });

    /* VIDEO MODALS */
    $('.link--play, .video-modal').magnificPopup({
      type: 'iframe',
      iframe: {
        markup:
          '<div class="mfp-iframe-scaler">' +
          '<div class="mfp-close"></div>' +
          '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
          '<div class="mfp-title">Some caption</div>' +
          '</div>',
      },
      callbacks: {
        markupParse: function (template, values, item) {
          values.title = item.el.attr('title');
        },
      },
    });
    /* END VIDEO MODALS */

    $('.mobile-icon').on('click', function () {
      $(this).toggleClass('mobile-icon--active');
      $('.site-header').toggleClass('site-header--mobile-nav-active');
      $('body').toggleClass('mobile-nav-active');
      $('.mobile-nav-container').toggleClass('mobile-nav-container--active');
    });

    $('.site-header__search-button').on('click', function (e) {
      e.preventDefault();
      $('.site-header').toggleClass('site-header--search-active');
    });

    /** MASTHEAD PRGRESSIVE IMAGES **/
    var masthead = document.querySelector('.masthead-image'),
      placeholderOverlay = document.querySelector('.masthead-image__overlay');

    if (masthead && placeholderOverlay) {
      // Load full size image. When loaded, fade our placeholder add it as bg to masthead
      var img = new Image();
      img.src = masthead.dataset.imageSrc;
      img.onload = function () {
        placeholderOverlay.classList.add('fade-out');
        masthead.style.backgroundImage = 'url(' + img.src + ')';
      };
    }
    /** END MASTHEAD PRGRESSIVE IMAGES **/

    // Masthead Animation
    function processMastheadAnimation() {
      if (!$('body').hasClass('template-sub-nav')) {
        imagesLoaded('.masthead-image, .masthead__video', function () {
          let $mastheadImage = $('.masthead-image, .masthead__video');
          let mastheadImageHeight = $mastheadImage.height();

          if (mastheadImageHeight === 0) {
            mastheadImageHeight = 687;
          }
          let scrollDistance = mastheadImageHeight / 2;

          $(document).ready(function () {
            let scrollPosition = $(window).scrollTop();

            $mastheadImage.css({
              opacity: (scrollDistance - scrollPosition) / scrollDistance,
            });
          });

          $(window).on('scroll', function () {
            let scrollPosition = $(window).scrollTop();

            $mastheadImage.css({
              opacity: (scrollDistance - scrollPosition) / scrollDistance,
            });
          });
        });
      }
    }

    processMastheadAnimation();

    $(window).resize(processMastheadAnimation);

    // Animations
    function itemReveal() {
      var itemQueue = [];
      var delay = 100;
      var queueTimer;

      function processItemQueue() {
        if (queueTimer) return; // We're already processing the queue
        queueTimer = window.setInterval(function () {
          if (itemQueue.length) {
            var el = itemQueue.shift();

            el.element.classList.add('revealed');
            processItemQueue();
          } else {
            window.clearInterval(queueTimer);
            queueTimer = null;
          }
        }, delay);
      }

      $('.reveal:not(.revealed)').waypoint(
        function () {
          itemQueue.push(this);
          processItemQueue();
        },
        {
          offset: '80%',
        }
      );

      $('.ticker:not(.revealed)').waypoint(
        function () {
          itemQueue.push(this.element);
          processItemQueue();
        },
        {
          offset: '85%',
        }
      );
    }

    itemReveal();

    var $darkTransitions = $('.dark-transition');

    $darkTransitions.each(function () {
      // eslint-disable-next-line no-unused-vars
      var firstViewWP = $(this).waypoint(
        function () {
          $('body').toggleClass('page--dark-bg');
        },
        {
          offset: '75%',
        }
      );
      if (!$(this).hasClass('dark-transition--end')) {
        // eslint-disable-next-line no-unused-vars
        var AllInWP = $(this).waypoint(
          function () {
            $('body').toggleClass('page--dark-bg');
          },
          {
            offset: function () {
              return -this.element.clientHeight + 500;
            },
          }
        );
      }
    });

    $(
      '.mobile-nav-container .mobile-menu > .mobile-menu__item--menu-item-has-children'
    ).on('click', function () {
      // When a heading is clicked, slide all sections up and remove active class
      var $menuItemParent = $(
        '.mobile-nav-container .mobile-menu > .mobile-menu__item--menu-item-has-children'
      );
      $menuItemParent.removeClass('menu-item--clicked');
      $(this).addClass('menu-item--clicked');

      $menuItemParent.each(function () {
        if (!$(this).hasClass('menu-item--clicked')) {
          $(this)
            .removeClass('menu-item--active')
            .find('.mobile-menu__sub-menu--1')
            .slideUp();
        }
      });

      // If the current clicked heading doesn't have an active state, slide section down
      if (!$(this).hasClass('menu-item--active')) {
        $(this).find('.mobile-menu__sub-menu--1').slideDown();
        // Add active state to clicked heading
        $(this).addClass('menu-item--active');
      } else {
        $(this)
          .removeClass('menu-item--active')
          .find('.mobile-menu__sub-menu--1')
          .slideUp();
      }
    });

    $('.main-menu > .main-menu__item').on('mouseenter', function () {
      $('.site-header').addClass('site-header--sub-menu-active');
    });

    $('.main-menu > .main-menu__item').on('mouseleave', function () {
      $('.site-header').removeClass('site-header--sub-menu-active');
    });

    /** ANIMATED ANCHOR LINKS **/
    $('a[href*="#"]:not([href="#"])').click(function (e) {
      // Doesn't do it on page builder tabs
      if (!$(this).closest('li').hasClass('vc_tta-tab')) {
        if (!$(this).closest('h4').hasClass('vc_tta-panel-title')) {
          if (
            location.pathname.replace(/^\//, '') ===
              this.pathname.replace(/^\//, '') &&
            location.hostname === this.hostname
          ) {
            var target = $(this.hash);
            var $this = this;
            var header = $('header.header');
            var wpAdminBar = $('#wpadminbar');
            var fixedHeaderOffset =
              parseInt(header.outerHeight()) -
              parseInt(header.css('padding-top').replace('px', ''));
            // If we're logged in and WP ADmin Bar exists, add it to the offset
            if (wpAdminBar.length) {
              fixedHeaderOffset += parseInt(wpAdminBar.outerHeight());
            }
            target = target.length
              ? target
              : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
              $('html,body').animate(
                {
                  scrollTop: target.offset().top - fixedHeaderOffset,
                },
                500,
                function () {
                  if (history.pushState) {
                    history.pushState(null, null, $this.hash);
                  } else {
                    location.hash = $this.hash;
                  }
                }
              );
              e.preventDefault();
            }
          }
        }
      }
    });
    /** END ANIMATED ANCHOR LINKS **/

    /* HEADER SCROLL EFFECT */
    // Reference: http://tympanus.net/codrops/2013/06/06/on-scroll-animated-header/
    // eslint-disable-next-line no-unused-vars
    var animatedHeader = (function () {
      // eslint-disable-line no-unused-vars
      var didScroll = false,
        scrollOffset = 500;

      function scrollY() {
        return window.pageYOffset || document.documentElement.scrollTop;
      }

      function scrollPage() {
        var sy = scrollY();
        if (sy > scrollOffset) {
          $('.site-header').addClass('site-header--scroll-triggered');
        } else {
          $('.site-header').removeClass('site-header--scroll-triggered');
        }
        didScroll = false;
      }

      function init() {
        window.addEventListener('load', scrollPage);
        window.addEventListener(
          'scroll',
          function () {
            // eslint-disable-line no-unused-vars
            if (!didScroll) {
              didScroll = true;
              setTimeout(scrollPage, 100);
            }
          },
          false
        );
      }
      init();
    })();
    /* END HEADER SCROLL EFFECT */

    if ($('.full-screen-scroll').length > 0 && $(window).outerWidth() > 992) {
      var fullScreenController = new ScrollMagic.Controller();
      var $impactDesignPartsImages = $('.full-screen-scroll__image');

      // On each scroll image, trigger scroll magic
      // eslint-disable-next-line no-unused-vars
      $impactDesignPartsImages.each(function (index, element) {
        // eslint-disable-line no-unused-vars
        new ScrollMagic.Scene({
          triggerElement: '.full-screen-scroll__container--' + (index + 1),
          duration: '100%',
        })
          // normally with ScrollMagic use use .setClassToggle for adding classes, but this only works with one element. So, we hook into the enter
          // and leave event and use jQuery to toggle the classes
          .on('enter', function (e) {
            // Do this if not the last item
            if (index + 1 < $impactDesignPartsImages.length) {
              $('.full-screen-scroll__image--' + (index + 1)).addClass(
                'full-screen-scroll__image--active'
              );
              $('.full-screen-scroll__control--' + (index + 1)).toggleClass(
                'full-screen-scroll__control--active'
              );
            } else {
              // This is special stuff for the last item. Instead of toggling the class, we are adding or removing the class depending on scroll direction (courtesy of ScrollMagic)
              if (e.scrollDirection === 'FORWARD') {
                $('.full-screen-scroll__image--' + (index + 1)).addClass(
                  'full-screen-scroll__image--active'
                );
                $('.full-screen-scroll__control--' + (index + 1)).addClass(
                  'full-screen-scroll__control--active'
                );
              }
            }
          })

          .on('leave', function (e) {
            // Do this if not the last item
            if (index + 1 < $impactDesignPartsImages.length) {
              $('.full-screen-scroll__image--' + (index + 1)).toggleClass(
                'full-screen-scroll__image--active'
              );
              $('.full-screen-scroll__control--' + (index + 1)).toggleClass(
                'full-screen-scroll__control--active'
              );
            } else {
              // This is special stuff for the last item. Instead of toggling the class, we are adding or removing the class depending on scroll direction (courtesy of ScrollMagic)
              if (e.scrollDirection === 'REVERSE') {
                $('.full-screen-scroll__image--' + (index + 1)).removeClass(
                  'full-screen-scroll__image--active'
                );
                $('.full-screen-scroll__control--' + (index + 1)).removeClass(
                  'full-screen-scroll__control--active'
                );
              } else {
                $('.full-screen-scroll__image--' + (index + 1)).addClass(
                  'full-screen-scroll__image--active'
                );
                $('.full-screen-scroll__control--' + (index + 1)).addClass(
                  'full-screen-scroll__control--active'
                );
              }
            }
          })
          .addTo(fullScreenController);
      });
    }

    let $parallaxImages = $('.parallax-image');

    $parallaxImages.each(function () {
      let imageHeight = $(this).height();

      if ($(this).hasClass('image--dot-decor-right')) {
        $(this).closest('.vc_column-inner ').addClass('image--dot-decor-right');
      } else if ($(this).hasClass('image--dot-decor')) {
        $(this).closest('.vc_column-inner ').addClass('image--dot-decor');
      }

      $(this)
        .removeClass('image--dot-decor')
        .removeClass('image--dot-decor-right')
        .removeClass('image--fold')
        .addClass('skrollable skrollable-between')
        .attr('data-bottom-top', 'top: -15%')
        .attr('data-top-bottom', 'top: 0%')
        .css({ height: '115%' })
        .closest('.wpb_wrapper')
        .height(imageHeight)
        .css({ position: 'relative', overflow: 'hidden' });
    });

    /** Break link text to new line when link text is a URL **/
    $(document).ready(function () {
      $('a').each(function () {
        var $this = $(this);
        var innerLink = $this.text();
        if (innerLink.startsWith('http')) {
          $this.css('word-break', 'break-all');
        }
      });
    });
    /** End Break link text to new line when link text is a URL **/

    var refineFilter = $('.refine-filter');
    var refineFilterHeading = $('.refine-filter__heading');
    var refineFilterHeadingIcon = $('.refine-filter__heading-icon');

    $('.btn--refine').on('click', function () {
      if (refineFilter) {
        refineFilter.addClass('refine-filter--active');
      }
    });

    $('.refine-filter__close').on('click', function () {
      if (refineFilter) {
        refineFilter.removeClass('refine-filter--active');
      }
    });

    refineFilterHeadingIcon.on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var $refineHeadings = $('.refine-filter__heading');
      // Add click class to item just clicked
      $refineHeadings.removeClass('refine-filter__heading--clicked');
      $(this)
        .closest('.refine-filter__heading')
        .addClass('refine-filter__heading--clicked');
      // When a heading is clicked, slide all sections up and remove active class for all items that weren't just clicked
      $refineHeadings.each(function () {
        if (!$(this).hasClass('refine-filter__heading--clicked')) {
          $(this)
            .removeClass('refine-filter__heading--active')
            .closest('.refine-filter__section')
            .find('.refine-filter__input')
            .slideUp();
        }
      });

      // If the current clicked heading doesn't have an active state, slide section down
      if (
        !$(this)
          .closest('.refine-filter__heading')
          .hasClass('refine-filter__heading--active')
      ) {
        $(this)
          .closest('.refine-filter__section')
          .find('.refine-filter__input')
          .slideDown();
        // Add active state to clicked heading
        $(this)
          .closest('.refine-filter__heading')
          .addClass('refine-filter__heading--active');
      } else {
        $(this)
          .closest('.refine-filter__heading')
          .removeClass('refine-filter__heading--active')
          .closest('.refine-filter__section')
          .find('.refine-filter__input')
          .slideUp();
      }
    });

    refineFilterHeading.on('click', function () {
      var $refineHeadings = $('.refine-filter__heading');
      // Add click class to item just clicked
      $refineHeadings.removeClass('refine-filter__heading--clicked');
      $(this).addClass('refine-filter__heading--clicked');
      // When a heading is clicked, slide all sections up and remove active class for all items that weren't just clicked
      $refineHeadings.each(function () {
        if (!$(this).hasClass('refine-filter__heading--clicked')) {
          $(this)
            .removeClass('refine-filter__heading--active')
            .closest('.refine-filter__section')
            .find('.refine-filter__input')
            .slideUp();
        }
      });

      // If the current clicked heading doesn't have an active state, slide section down
      if (!$(this).hasClass('refine-filter__heading--active')) {
        $(this)
          .closest('.refine-filter__section')
          .find('.refine-filter__input')
          .slideDown();
        // Add active state to clicked heading
        $(this).addClass('refine-filter__heading--active');
      } else {
        $(this)
          .removeClass('refine-filter__heading--active')
          .closest('.refine-filter__section')
          .find('.refine-filter__input')
          .slideUp();
      }
    });

    // Toggle Award Details
    function toggleListItemGrant() {
      var $listItemGrants = $('.list-item-grant__top');
      $('.list-item-grant__top').on('click', function () {
        $(this)
          .closest('.container')
          .find('.list-item-grant__bottom')
          .slideToggle('fast');
      });
      $listItemGrants.on('click', function () {
        // Add click class to item just clicked
        $listItemGrants.removeClass('list-item-grant__top--clicked');
        $(this).addClass('list-item-grant__top--clicked');
        // When a heading is clicked, slide all sections up and remove active class for all items that weren't just clicked
        $listItemGrants.each(function () {
          if (!$(this).hasClass('list-item-grant__top--clicked')) {
            $(this)
              .closest('.list-item-grant')
              .removeClass('list-item-grant__top--active');
            $(this)
              .closest('.container')
              .find('.list-item-grant__bottom')
              .slideUp();
          }
        });

        // If the current clicked heading doesn't have an active state, slide section down
        if (
          !$(this)
            .closest('.list-item-grant')
            .hasClass('list-item-grant__top--active')
        ) {
          $(this)
            .closest('.container')
            .find('.list-item-grant__bottom')
            .slideDown();
          // Add active state to clicked heading
          $(this)
            .closest('.list-item-grant')
            .addClass('list-item-grant__top--active');
        } else {
          $(this)
            .closest('.list-item-grant')
            .removeClass('list-item-grant__top--active');
          $(this)
            .closest('.container')
            .find('.list-item-grant__bottom')
            .slideUp();
        }
      });
    }

    toggleListItemGrant();
    if ($('body').hasClass('insights')) {
      // eslint-disable-next-line no-unused-vars
      var $grid = $('.insights-list .posts-list-container').imagesLoaded(
        function () {
          $('.insights-list .posts-list-container').masonry({
            itemSelector: '.insights-list .posts-list-container .column',
            stagger: 100,
            hiddenStyle: {
              opacity: 0,
            },
            visibleStyle: {
              opacity: 1,
            },
          });
        }
      );
    }

    // AJAX Load More
    function visc_load_more() {
      if (visceral_vars !== undefined) {
        var data = {
          action: 'visc_load_more',
          query: visceral_vars.query,
          paged: visceral_vars.current_page,
          security: visceral_vars.security,
        };

        var $button = $('.btn--load-more');

        $.ajax({
          url: visceral_vars.ajaxurl, // AJAX handler
          data: data,
          type: 'POST',
          beforeSend: function () {
            $button.find('span').text('Loading...'); // change the button text, you can also add a preloader image
          },
          complete: function () {
            itemReveal();
          },
          success: function (data) {
            $button.blur();
            if (data) {
              $button.find('span').text('Load More');

              if ($('body').hasClass('insights')) {
                var elements = $.parseHTML(data);
                // We need to pass jquery objects to masonry with the append method
                var $elements = $(elements);

                $grid.append($elements).masonry('appended', $elements);
              } else {
                var $postsContainer = $('.posts-list-container');
                $postsContainer.append(data);
              }

              visceral_vars.current_page++;

              if (visceral_vars.current_page == visceral_vars.max_page) {
                $button.remove(); // if last page, remove the button
              }
              toggleListItemGrant();
            } else {
              $button.remove(); // if last page, remove the button
            }
          },
        });
      }
    }

    $('.btn--load-more').on('click', function () {
      visc_load_more();
    });

    // Generic Slider
    // slick slide
    if ($('.visceral-slider').length > 0) {
      var viscSlider = $(
        '.visceral-slider > .wpb_column > .vc_column-inner > .wpb_wrapper'
      );

      viscSlider.slick({
        slide:
          '.visceral-slider > .wpb_column > .vc_column-inner > .wpb_wrapper > *',
        autoplay: true,
        autoplaySpeed: 8000,
        infinite: true,
        centerMode: true,
        centerPadding: '50px',
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        dots: false,
        arrows: true,
        fade: false,
        mobileFirst: true,
        prevArrow:
          '<button type="button" class="slick-prev"><span class="icon icon-big-arrow"></span><span class="screen-reader-text">Previous</span></button>',
        nextArrow:
          '<button type="button" class="slick-next"><span class="icon icon-big-arrow"></span><span class="screen-reader-text">Next</span></button>',
        responsive: [
          {
            breakpoint: 768,
          },
        ],
      });
    }

    if ($('.visceral-slider-column').length > 0) {
      var columnSlider = $(
        '.visceral-slider-column.wpb_column > .vc_column-inner > .wpb_wrapper'
      );

      columnSlider.slick({
        slide:
          '.visceral-slider-column.wpb_column > .vc_column-inner > .wpb_wrapper > *',
        autoplay: true,
        autoplaySpeed: 8000,
        infinite: true,
        centerMode: false,
        // centerPadding: '50px',
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        dots: false,
        arrows: true,
        fade: false,
        mobileFirst: true,
        prevArrow:
          '<button type="button" class="slick-prev"><span class="icon icon-big-arrow"></span><span class="screen-reader-text">Previous</span></button>',
        nextArrow:
          '<button type="button" class="slick-next"><span class="icon icon-big-arrow"></span><span class="screen-reader-text">Next</span></button>',
      });
    }

    // Related carousel
    if ($('.posts-slider .row').length > 0) {
      // eslint-disable-next-line no-unused-vars
      var slider = $('.posts-slider .row');

      slider.slick({
        slide: '.posts-slider .row .column',
        //    autoplay: true,
        //    autoplaySpeed: 8000,
        infinite: false,
        //    centerMode: true,
        //    centerPadding: '50px',
        //    cssEase: 'linear',
        slidesToShow: 1,
        variableWidth: false,
        //    slidesToScroll: 1,
        //    swipeToSlide: true,
        //    dots: true,
        //    arrows: true,
        //    fade: false,
        mobileFirst: true,
        prevArrow:
          '<button type="button" class="slick-prev"><span class="icon icon-big-arrow"></span><span class="screen-reader-text">Previous</span></button>',
        nextArrow:
          '<button type="button" class="slick-next"><span class="icon icon-big-arrow"></span><span class="screen-reader-text">Next</span></button>',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              variableWidth: true,
            },
          },
        ],
      });
    }

    $('.single-related-content .row, .featured-grants .row').on(
      'setPosition',
      function () {
        $(this).find('.slick-slide').height('auto');
        var slickTrack = $(this).find('.slick-track');
        var slickTrackHeight = $(slickTrack).height();
        $(this)
          .find('.slick-slide')
          .css('height', slickTrackHeight + 'px');
      }
    );

    // Featured Grants carousel
    if ($('.featured-grants .row').length > 0) {
      // eslint-disable-next-line no-unused-vars
      var grantsSlider = $('.featured-grants .row');

      grantsSlider.slick({
        slide: '.featured-grants .row .column',
        //    autoplay: true,
        //    autoplaySpeed: 8000,
        infinite: false,
        //    centerMode: true,
        //    centerPadding: '50px',
        //    cssEase: 'linear',
        slidesToShow: 1,
        //    slidesToScroll: 1,
        //    swipeToSlide: true,
        //    dots: true,
        //    arrows: true,
        //    fade: false,
        mobileFirst: true,
        prevArrow:
          '<button type="button" class="slick-prev"><span class="icon icon-big-arrow"></span><span class="screen-reader-text">Previous</span></button>',
        nextArrow:
          '<button type="button" class="slick-next"><span class="icon icon-big-arrow"></span><span class="screen-reader-text">Next</span></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
            },
          },
        ],
      });
    }

    // Main Nav Accessibility
    let $mainNavigationTopLevelItemLinks = $(
      '.site-header .main-menu > .main-menu__item--parent > button'
    );

    if ($mainNavigationTopLevelItemLinks.length) {
      $mainNavigationTopLevelItemLinks.each(function () {
        $(this).prev('a').attr('aria-haspopup', 'true');
        $(this).on('click', function () {
          console.log('click!');

          $(this).closest('li').toggleClass('sub-menu-open');
          $(this).attr('aria-expanded', 'true');
        });
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is firedo

    function parallaxImageDecor() {
      let parallaxImages = $('.image--dot-decor.vc_parallax');

      parallaxImages.each(function () {
        if ($(this).is(':first-child')) {
          $(this).closest('.vc_row').addClass('image--dot-decor');
        } else {
          $(this).prev('.vc_column_container').addClass('image--dot-decor');
        }
      });
    }

    parallaxImageDecor();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js